import { render, staticRenderFns } from "./LsFooter.vue?vue&type=template&id=63dae57c&scoped=true&"
import script from "./LsFooter.vue?vue&type=script&lang=js&"
export * from "./LsFooter.vue?vue&type=script&lang=js&"
import style0 from "./LsFooter.vue?vue&type=style&index=0&id=63dae57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dae57c",
  null
  
)

export default component.exports